import {
  Box,
  TableContainer,
  Table,
  TableCell,
  TableHead,
  TableRow,
  TableBody,
} from "@mui/material";
import dayjs from "dayjs";
import { grey } from "@mui/material/colors";
import React from "react";
import { SupplyPlanScheduled } from "api/models/SupplyPlan";

interface SupplyPlanDataProps {
  data: SupplyPlanScheduled[];
}

const SupplyPlanData = ({ data }: SupplyPlanDataProps) => {
  return (
    <Box>
      <TableContainer>
        <Table
          size="small"
          stickyHeader
          sx={{
            "& .MuiTableRow-root:hover": {
              backgroundColor: grey[200],
            },
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  bgcolor: grey[300],
                  borderRight: `1px solid ${grey[400]}`,
                  borderBottom: `1px solid ${grey[400]}`,
                  fontSize: "13px",
                  width: "40px",
                  position: "sticky",
                  left: 0,
                  zIndex: "9",
                }}
              >
                Period
              </TableCell>
              {data.map((col) => (
                <TableCell
                  key={`Col-${col.priceStep}`}
                  align="right"
                  sx={{
                    bgcolor: grey[300],
                    borderBottom: `1px solid ${grey[400]}`,
                    fontSize: "11px",
                  }}
                >
                  {col.priceStep}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data[0].values.map((period, rowIndex) => (
              <TableRow key={`Period-${period}`}>
                <TableCell
                  sx={{
                    bgcolor: grey[300],
                    borderRight: `1px solid ${grey[400]}`,
                    fontSize: "11px",
                    width: "40px",
                    position: "sticky",
                    left: 0,
                  }}
                >
                  {dayjs
                    .tz(dayjs(period.periodStart).utc(), "Europe/Oslo")
                    .format("HH:mm")}
                </TableCell>
                {data.map((col, colIndex: number) => (
                  <TableCell
                    key={`ColRow-${rowIndex}-${colIndex}`}
                    align="right"
                    sx={{ fontSize: "11px" }}
                  >
                    {col.values[rowIndex].quantity}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default SupplyPlanData;
